import React from "react";
import DocumentElementCard from "./DocumentElementCard";
import ImageElementCard from "./ImageElementCard";
import InspectionElement from "../../types/InspectionElement";
import { AssetType } from "../../types/AssetType";
import CheckListElementCard from "./CheckListElementCard";

interface Props {
    readonly assetType: AssetType;
    readonly element: InspectionElement;
    readonly deleteDialogCallback?: (open : boolean) => void;
}

export default function ArtifactElementCard({ assetType, element , deleteDialogCallback }: Readonly<Props>) {
    let assetCard;

    switch (assetType) {
        case AssetType.Image:
            assetCard = <ImageElementCard element={element} deleteDialogCallback={deleteDialogCallback}  />;
            break;
        case AssetType.Document:
            assetCard = <DocumentElementCard elementId={element.Id} />;
            break;
        case AssetType.CheckList:
            assetCard = <CheckListElementCard elementId={element.Id} />;
            break;
    }

    return <div>{assetCard}</div>;
}
